import React from "react";
import MainScreenDividingLine from "../MainScreenDividingLine";
import MainScreenRightSidebar from "../MainScreenRightSidebar";
import "./BaseContainerDividingLineRHSSidebar.css";

const BaseContainerDividingLineRHSSidebar = () => {

  return (
    <div className="base-container-dividing-line-rhs-sidebar">
      <MainScreenDividingLine />
      <MainScreenRightSidebar />
    </div>
  );
}

export default BaseContainerDividingLineRHSSidebar;
